import styled from 'styled-components';

export default styled.div`
	display: grid;
	gap: var(--spacing-medium);
	grid-template-columns: var(--gm-grid);
	padding-top: var(--spacing-large);
	padding-bottom: var(--spacing-x-large);

	.half-row {
		grid-column: span 3;
	}
	.full-row {
		grid-column: span 6;
	}
`;
